const units = [
    { text: "tons", value: 1 },
    { text: "Kg", value: 2 },
    { text: "scm", value: 3 }
]
const vehicleType = [
    { text: "MCV", value: 77 },
    { text: "Tanker", value: 84 },
]

const stationTypes = [
    { text: "Terminal", value: 1, sellingProduct: "LNG", buyingProduct: null },
    { text: "Station", value: 2, sellingProduct: "CNG", buyingProduct: "LNG" },
    { text: "CNG Customer", value: 3, sellingProduct: null, buyingProduct: "CNG" },
    { text: "DBS", value: 4, sellingProduct: null, buyingProduct: "CNG" },
    { text: "LNG Customer", value: 5, sellingProduct: null, buyingProduct: "LNG" },
]
const driverType = [
    { text: "CNG Vehicle - Rigid", value: 67 },
    { text: "LNG Vehicle - Articulated", value: 65 },
    { text: "LNG Vehicle - Rigid", value: 82 },
]

const verificationStatus = [
    { text: "No Document", value: 0, color: "warning" },
    { text: "Not Verified", value: 1, color: "amber" },
    { text: "Rejected", value: 10, color: "red darken-4" },
    { text: "Validity Expired", value: 20, color: "purple" },
    { text: "Verified", value: 90, color: "green" },
]
const typeOfVehicle = [
    {
        text: "Articulated",
        value: 65
    },
    {
        text: "Rigid",
        value: 82
    }
]
const userTypes = [
    { text: "Admin", value: 2 },
    { text: "LNG CLP", value: 3 },
    { text: "LNG LLP", value: 4 },
    { text: "LNG Approver", value: 5 },
    { text: "CNG CLP", value: 6 },
    { text: "CNG LLP", value: 7 },
    { text: "CNG Approver", value: 8 },
    { text: "Driver", value: 9 },
]
const products = [
    { text: "LNG", value: 1 },
    { text: "CNG", value: 2 },
    { text: "CBG", value: 3 },
]

const windowTimings
 = [
    { text: "Mon", value: 1 },
    { text: "Tue", value: 2 },
    { text: "Wed", value: 3 },
    { text: "Thu", value: 4 },
    { text: "Fri", value: 5 },
    { text: "Sat", value: 6 },
    { text: "Sun", value: 7 },
]

const orderStatus = [
    { text: "Created", value: 0, color: "amber", filter: true },
    { text: "Edited", value: 2, color: "orange", filter: true },
    { text: "Rejected", value: 5, color: "red", filter: true },
    { text: "VOR Rejected", value: 9, color: "pink" },
    { text: "Vehicle Rejected", value: 10, color: "pink" },
    { text: "RVOR Rejected", value: 11, color: "pink" },
    { text: "VOR Approved", value: 14, color: "cyan" },
    { text: "Approved", value: 15, color: "cyan" },
    { text: "RVO Requested", value: 16, color: "orange" },
    { text: "PostTrip RVOR Approved", value: 17, color: "orange" },
    { text: "PostTrip Inspection Completed", value: 18, color: "light-blue" },
    { text: "DOR Rejected", value: 19, color: "pink" },
    { text: "PreTrip Inspection Completed", value: 20, color: "blue" },
    { text: "Driver Assigned", value: 21, color: "orange" },
    { text: "RVOR Approved", value: 24, color: "cyan" },
    { text: "DOR Approved", value: 25, color: "cyan" },
    { text: "DN Generated", value: 30, color: "lime" },
    { text: "Trip Started", value: 35, color: "light-green" },
    { text: "Trip Deviated", value: 40, color: "purple" },
    { text: "Partially Delivered", value: 50, color: "teal darken-4" },
    { text: "Acknowledgement Updated", value: 55, color: "teal darken-4" },
    { text: "Delivered", value: 60, color: "teal" },
    { text: "Trip Ended", value: 80, color: "cyan accent-4" },
    { text: "Closed", value: 90, color: "green" },
    { text: "Canceled", value: 99, color: "red darken-4" }
]

const orderDetailStatus = [
    { text: "Ready", value: 0 },
    { text: "InTrip", value: 1 },
    { text: "Delivered", value: 2 },
    { text: "Removed", value: 3 },
    { text: "Cancelled", value: 4 },
    { text: "Aborted", value: 5 }
]

const vehicleStatus = [
    { text: "Available(InStation)", value: 5, color: "green" },
    { text: "Available", value: 10, color: "green" },
    { text: "Available(OutStation)", value: 20, color: "green" },
    { text: "Delivered", value: 21, color: "green" },
    { text: "Partially Delivered", value: 25, color: "cyan" },
    { text: "InTrip", value: 35, color: "info" },
    { text: "Loading(AtStation)", value: 40, color: "info" },
    { text: "Assigned", value: 50, color: "primary" },
    { text: "In Maintenance", value: 60, color: "red" },
    { text: "Blacklist", value: 99, color: "#424242" },
]

const driverStatus = [
    { text: "Available", value: 1, color: "primary" },
    { text: "Assigned", value: 2, color: "green" },
    { text: "In Trip", value: 3, color: "cyan" },
    { text: "On Leave", value: 4, color: "pink" },
    { text: "Not In Operation", value: 5, color: "#ff0000" },
    { text: "Blacklist", value: 99, color: "balck" },
]

const cascadeTypes = [
    { text: "Type-1  3000WL", value: 1, cascadeCapacity: 3000, cascadeType: 1, noOfCylinder: 40, lowBank: 20, mediumBank: 12, highbank: 8 },
    { text: "Type-1  4500WL", value: 2, cascadeCapacity: 4500, cascadeType: 1, noOfCylinder: 60, lowBank: 30, mediumBank: 18, highbank: 12 },
    { text: "Type-3  9024WL", value: 3, cascadeCapacity: 9024, cascadeType: 3, noOfCylinder: 32, lowBank: 16, mediumBank: 8, highbank: 8 },
    { text: "Type-3  9056WL", value: 4, cascadeCapacity: 9056, cascadeType: 3, noOfCylinder: 32, lowBank: 16, mediumBank: 8, highbank: 8 },
    { text: "Type-3  9810WL", value: 5, cascadeCapacity: 9810, cascadeType: 3, noOfCylinder: 30, lowBank: 15, mediumBank: 8, highbank: 7 },
    { text: "Type-4 9360WL", value: 6, cascadeCapacity: 9360, cascadeType: 4, noOfCylinder: 60, lowBank: 31, mediumBank: 17, highbank: 12 },
    { text: "Type-4 8580WL", value: 7, cascadeCapacity: 8580, cascadeType: 4, noOfCylinder: 55, lowBank: 28, mediumBank: 16, highbank: 11 }
]

const typeOfRequest = [
    { text: "Unverified Vehilce Override", value: "10" },
    { text: "Inmaintenance Vehilce Override", value: "20" },
    { text: "Unverified Driver Override", value: "30" },
]

const stateCodes = [
    { text: "RAJASTHAN", code: "08", value: "8" },
    { text: "GUJARAT", code: "24", value: "24" },
    { text: "UTTAR PRADESH", code: "09", value: "9" },
    { text: "TELANGANA", code: "36", value: "36" },
    { text: "TAMIL NADU	", code: "33", value: "33" },
    { text: "KERALA	", code: "32", value: "32" }
]
const revervedCriticalPoints = ["newDentCascadeVehicle", "leakageFromFuelTank", "5thWheelAssembly"]

export default {
    units,
    vehicleType,
    stationTypes,
    windowTimings,
    userTypes,
    orderStatus,
    orderDetailStatus,
    products,
    vehicleStatus,
    stateCodes,
    typeOfVehicle,
    driverType,
    driverStatus,
    verificationStatus,
    cascadeTypes,
    typeOfRequest,
    revervedCriticalPoints
}